import { useState, useEffect } from 'react';
import fallbackImg from '../../../../../../public/assets/no-profile-image.png';

export const useImageLoader = (src: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [finalSrc, setFinalSrc] = useState(src);

  useEffect(() => {
    const img = new Image();
    setLoading(true);
    setError(false);

    img.src = src;

    img.onload = () => {
      setLoading(false);
      setFinalSrc(src);
    };

    img.onerror = () => {
      setLoading(false);
      setError(true);
      setFinalSrc(fallbackImg);
    };
  }, [src]);

  return { src: finalSrc, loading, error };
};
